import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'antd';
import { useNavigate } from "react-router-dom";
import useStatsStore from "../../store/stats.store"
import "./InterviewCountCard.scss"
function InterviewCountCard() {
  const navigate = useNavigate();
  const { interviewSchedules, getInterviewSchedule } = useStatsStore();
    const [interviewCount, setInterviewCount] = useState({
        Total: 0,
        L0: 0,
        L1: 0,
        L2: 0,
        Customer: 0,
        HR: 0,
        Management: 0,
    });

    useEffect(() => {
        getInterviewSchedule();

    },[])

    useEffect(() => {
    getInterviewsToday();

    }, [interviewSchedules]);

    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = today.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    const getInterviewsToday = () => {
    let count = {
      Total: 0,
        L0: 0,
        L1: 0,
        L2: 0,
        Customer: 0,
        HR: 0,
        MgMT: 0,
    };
    const today = getCurrentDate();
    const interviewJds = interviewSchedules?.JDListInterview;

    for (let i = 0; i < interviewJds?.length; i++) {
      for (let j = 0; j < interviewJds[i]?.InterviewItem?.length; j++) {
        if (interviewJds[i]?.InterviewItem[j]?.interviewdate == today) {
          count.Total += 1;
          switch (interviewJds[i]?.InterviewItem[j]?.type) {
            case "L0":
              count.L0 += 1;
              break;
            case "L1":
              count.L1 += 1;
              break;
            case "L2":
              count.L2 += 1;
              break;
            case "Customer":
              count.Customer += 1;
              break;
            case "HR":
              count.HR += 1;
              break;
            case "MgMT":
              count.MgMT += 1;
              break;
            default:
              break;
            }
        }
      }
    }
    setInterviewCount(count);
    return count;
};

  return (
    <div className="interview-count-card-wrapper">
      <h5 className="interview-count-card-title">Interviews Today</h5>
      <div className="interview-count-card-container">
        <Card
          className="interview-count-card"
          title="Total"
          variant="borderless"
          // style={{ backgroundColor: "#fff" }}
          headStyle={{ backgroundColor: "#cce9ff" }} // Change header background and text color
          onClick={() => {
            navigate("/InterviewCalendar");
          }}
        >
          {interviewCount.Total}
                </Card>
        <Card
          className="interview-count-card"
          headStyle={{ backgroundColor: "#cce9ff" }}
          title="L0"
          variant="borderless"
          onClick={() => {
            navigate("/InterviewCalendar");
          }}
        >
                {interviewCount.L0}
                </Card>
        <Card
          className="interview-count-card"
          headStyle={{ backgroundColor: "#cce9ff" }}
          title="L1"
          variant="borderless"
          onClick={() => {
            navigate("/InterviewCalendar");
          }}
        >
                {interviewCount.L1}
                </Card>
        <Card
          className="interview-count-card"
          headStyle={{ backgroundColor: "#cce9ff" }}
          title="L2"
          variant="borderless"
          onClick={() => {
            navigate("/InterviewCalendar");
          }}
        >
                {interviewCount.L2}
                </Card>
        <Card
          className="interview-count-card"
          headStyle={{ backgroundColor: "#cce9ff" }}
          title="Customer"
          variant="borderless"
          onClick={() => {
            navigate("/InterviewCalendar");
          }}
        >
                {interviewCount.Customer}
                </Card>
        <Card
          className="interview-count-card"
          headStyle={{ backgroundColor: "#cce9ff" }}
          title="HR"
          variant="borderless"
          onClick={() => {
            navigate("/InterviewCalendar");
          }}
        >
                {interviewCount.HR}
                </Card>
        <Card
          className="interview-count-card"
          headStyle={{ backgroundColor: "#cce9ff" }}
          title="Management"
          variant="borderless"
          onClick={() => {
            navigate("/InterviewCalendar");
          }}
        >
                {interviewCount.MgMT}
                </Card>
      </div>
    </div>
  );
}

export default InterviewCountCard;
